export const pipelineId = '3fbb9e0a-1a22-4a11-9e33-5c0a1a111111';
export const integrationId = '7c2d9e10-2b33-4a11-9e33-5c0a1a111111';
export const pipelineIntegrationId = 'e2f2a3a3-0000-4a11-9e33-5c0a1a111111';
export const writekey = 'wk_live_9f8a7b6c5d4e';
export const clusterId = 'c1a1a1a1-0000-4a11-9e33-5c0a1a111111';
export const schemaId = 'a1b1c1d1-0000-4a11-9e33-5c0a1a111111';
export const schemaLibraryId = 'b2c2d2e2-0000-4a11-9e33-5c0a1a111111';
export const schemaLibraryVersionId = 'c3d3e4e4-0000-4a11-9e33-5c0a1a111111';
export const pipelineSchemaLibraryId = 'd4e4f5f5-0000-4a11-9e33-5c0a1a111111';
export const eventNameId = 'e5f5a6a6-0000-4a11-9e33-5c0a1a111111';
export const eventSchemaId = 'f6a6b7b7-0000-4a11-9e33-5c0a1a111111';
export const sampleEventId = 'b8c8d9d9-0000-4a11-9e33-5c0a1a111111';
export const stagedRevisionId = 'c4d4e4f4-0000-4a11-9e33-5c0a1a111111';
export const tagId = 'f1a1a1a1-0000-4a11-9e33-5c0a1a111111';
export const consentCategoryId = 'a2b2c2d2-0000-4a11-9e33-5c0a1a111111';
export const subjectId = 'auth0|64f1a1a1a1a1a1a1a1a1a1a1';
export const userId = 'd5e5f5a5-0000-4a11-9e33-5c0a1a111111';
export const libraryWideEventSchemaId = 'a7b7c8c8-0000-4a11-9e33-5c0a1a111111';
export const playbookId = 'b3c3d3e3-0000-4a11-9e33-5c0a1a111111';
